// extracted by mini-css-extract-plugin
module.exports = {"imageslider":"ImageSliderSecond_imageslider__2akZ-","sliderbutton":"ImageSliderSecond_sliderbutton__1M1nA","sliderimage":"ImageSliderSecond_sliderimage__2oDuE"};